import { ApiServiceCredentials } from '@barbanet/api-service'
import { defineStore } from 'pinia'

import { computed, inject, ref } from 'vue'
import { VueCookies } from 'vue-cookies'
import { useRoute, useRouter } from 'vue-router'

import { CREDENTIALS_COOKIE } from '../helpers/cookie'

export const useAccountStore = defineStore('account', () => {
	const $cookies = inject<VueCookies>('$cookies')
	const router = useRouter()
	const route = useRoute()

	// get account from cookies if exists to set as initial value
	let accountFromCookie = $cookies?.get(CREDENTIALS_COOKIE.key)
	if (accountFromCookie) {
		accountFromCookie = accountFromCookie as BarbanetCredentials
	}

	const credentials = ref<BarbanetCredentials | null>(accountFromCookie || null)
	const isLoggedIn = computed(() => !!credentials.value)

	const logout = () => {
		credentials.value = null
		$cookies?.remove(CREDENTIALS_COOKIE.key)

		router.replace({ name: 'AuthenticatePage', query: { to: route.fullPath } })
	}

	const setCredentials = (
		data: BarbanetCredentials | ApiServiceCredentials
	) => {
		const newCredentials = { ...(credentials.value || {}), ...data }

		if (newCredentials.userId) {
			credentials.value = newCredentials as BarbanetCredentials
			$cookies?.set(
				CREDENTIALS_COOKIE.key,
				newCredentials,
				CREDENTIALS_COOKIE.expires,
				CREDENTIALS_COOKIE.path,
				undefined,
				CREDENTIALS_COOKIE.secure,
				CREDENTIALS_COOKIE.sameSite
			)
		} else {
			logout()
		}
	}

	return {
		credentials,
		isLoggedIn,
		setCredentials,
		logout
	}
})
